<template>
<div id="downgrade-form">
    <form @submit.prevent="showModal" class="bg-ma-gray-0 py-4 -mx-3 md:mx-0 md:mb-10">
        <Message
            v-if="error"
            class="mb-3"
            :message="error"
        />

        <div class="md:flex md:mx-6">
            <div class="md:w-1/2 md:mr-4 mx-6 md:mx-0 ">
                <h4 class="font-semibold text-xl text-center md:text-left mb-2">
                    Reason for downgrade
                </h4>

                <div class="mb-4">
                    <textarea class="textarea-height w-full px-4 py-3 text-base"
                        rows="6"
                        v-model="feedback"
                        name="downgrade_feedback" 
                        placeholder="Please tell us why you are downgrading? Maybe we can help."
                    ></textarea>

                    <small class="text-ma-gray-3 px-4 block text-center md:text-left md:px-0 md:mt-6">
                        *Changes to your account will take place at the end of your current billing period.
                    </small>
                </div>
            </div>

            <div class="md:w-1/2 md:ml-4 ">
                <h4 class="font-semibold text-xl text-center md:text-left mx-4 md:mx-0 mb-2">By downgrading, you confirm the following...</h4>
                <div class="textarea-height bg-ma-gray-11 p-6 uppercase">
                    <ol class="mb-6">
                        <li class="mb-4">You will no longer be able to use motion array assets in new projects.</li>
                        <li class="mb-4">Any review or portfolio sites that you have created will be deleted.</li>
                        <li>Any premium plugins that you have used will be watermarked.</li>
                    </ol>
                    <label class="ma-checkbox font-semibold" :class="{ 'ma-checkbox--checked': accept }">
                        <input type="checkbox" v-model="accept" name="accept" />
                        <span class="ma-checkbox__toggle"></span>

                        <div class="ma-checkbox__label">
                        I understand the above
                        </div>
                    </label>
                </div>
            
                <div class="text-center text-sm flex flex-col sm:flex-row sm:justify-center lg:justify-end mt-6 mb-4 md:mb-2">
                    <a class="capitalize font-semibold py-2 w-48 mx-auto sm:mx-0 sm:mr-4 border-ma-gray-22 text-ma-gray-22 border-2 hover:text-white hover:bg-ma-gray-22" href="/account/subscription">
                        No, don’t downgrade
                    </a>
                    <button :class="buttonClasses" class="bg-ma-gray-22 hover:bg-ma-gray-3 capitalize font-semibold py-2 w-48 mx-auto sm:mx-0 text-white mt-4 sm:mt-0" type="submit">
                        Downgrade now
                    </button>
                </div>
            </div>
        </div>
    </form>

    <DowngradeModal v-if="modalVisible" @close="closeModal" @downgrade="downgrade" :loading="loading" />
</div>
</template>

<script>
import axios from 'axios';
import Message from '@/components/Message';
import DowngradeModal from './DowngradeModal';

export default {
    components: {
        Message,
        DowngradeModal
    },

    data: () => ({
        error: '',
        loading: false,
        accept: false,
        modalVisible: false,
        feedback: '',
    }),

    computed: {
        buttonClasses() {
            let buttonEnabled = this.accept && this.feedback.trim();

            return {
                "bg-ma-red-1 hover:bg-ma-red-2": buttonEnabled
            };
        }
    },

    methods: {
        showModal() {
            this.modalVisible = true;
        },

        closeModal() {
            this.modalVisible = false;
        },

        async downgrade() {
            this.loading = true;

            try {
                let response = await axios.post('/account/subscription/schedule-cancel', {
                    downgrade_feedback: this.feedback,
                    accept: this.accept
                });

                let plan = response.data.downgradedFromPlan;
                window.location.href = '/account/subscription' +
                    (plan ? '?downgrade=true&from_plan=' + plan : '');

            } catch (e) {
                this.error = e.response.data.message;

                this.closeModal();

                this.loading = false;
            }
        }
    }
}
</script>